const React = require('react');
const Ripple = require('../../../../Ripple');
const {paramStore} = require('../../../../../../stores');
const withState = require('../../../../../../utils/withState');
const generateUUID = require('../../../../../../utils/generateUUID');
const {BtnDeletable} = require('../../../Buttons');

const OwnerForm = require('./components/OwnerForm');
const {openPopupInfo} = require("../../../../../../emitters/popup");

const ownerId$ = paramStore('businessOwner');

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    ownersListIDs: self.props.ownersList && self.props.ownersList.length ? self.props.ownersList.map((el) => el.id) : [generateUUID()],
    loading: false
  };

  onMount(() => {
    const currentOwnerId = ownerId$.getValue();
    const ownersListIDs = self.state.ownersListIDs || [];

    if (!currentOwnerId || !ownersListIDs.includes(currentOwnerId)) {
      ownerId$.emit(ownersListIDs[0]);
    }

    return () => ownerId$.emit('');
  })

  const selectActiveHolder = (ownerId) => {
    setState({loading: true});
    ownerId$.emit(ownerId);
    setTimeout(() => {
      setState({loading: false})
    }, 100);
  }

  return (state, props) => {
    const {ownerId, ownersListIDs, loading} = state;
    const {activeUserId, ownersList = [], requestCreate, requestUpdate, requestDelete, onNextStep} = props;

    const activeOwnerIndex = ownersListIDs.findIndex((id) => id === ownerId);
    const activeOwner = ownersList[activeOwnerIndex] || {};
    const otherOwnersShares = ownersList.reduce((acc, next) => {
      if (next.id !== ownerId) {
        acc += Number(next.owner_percent);
      }
      return acc;
    }, 0);

    return (
      <>
        <div className="layoutRow aiC">
          {ownersListIDs.map((id, index) => {
            const ownerData = ownersList[index];
            const isActive = id === ownerId;

            return (
              <div key={id} className="mr16">
                <BtnDeletable
                  onClick={() => {
                    selectActiveHolder(id)
                  }}
                  onDelete={() => {
                    const needRequest = !!ownerData && requestDelete;

                    const req = needRequest
                      ? requestDelete
                      : () => new Promise((res) => res());

                    setState({loading: true});

                    req({id})
                        .then(() => {
                          const listWillBeEmpty = ownersListIDs.length === 1;

                          const newRandomId = generateUUID();

                          const nextOwnersList = listWillBeEmpty
                            ? [newRandomId]
                            : ownersListIDs.filter((ownerId) => ownerId !== id);

                          setState({ownersListIDs: nextOwnersList});

                          if (id === ownerId) {
                            let nextId = newRandomId

                            if (!listWillBeEmpty) {
                              const indexOfDeleted = ownersListIDs.findIndex((ownerId) => ownerId === id);
                              nextId = nextOwnersList[[0, 1].includes(indexOfDeleted) ? 0 : indexOfDeleted - 1];
                            }

                            ownerId$.emit(nextId);
                          }
                        })
                        .then(props.resetUserData)
                        .then(() => {
                          if (needRequest) openPopupInfo([`You\'ve deleted owner ${ownerData.full_name}`])
                        })
                        .finally(() => setState({loading: false}));
                  }}
                  isActive={isActive}
                  deleteIsHidden={!activeOwner.full_name && ownersListIDs.length === 1}
                >
                  {`${Number(index) + 1}. ${(ownerData && ownerData.full_name) || 'UBO / Shareholder'}`}
                </BtnDeletable>
              </div>
            )
          })}
          <Ripple
            className="h45 layoutRow aiC"
            onClick={() => {
              const nextId = generateUUID();
              setState({ownersListIDs: [...ownersListIDs, nextId]});
              selectActiveHolder(nextId);
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="#3E4044"/>
              <path d="M11 5H13V19H11V5Z" fill="white"/>
              <path d="M19 11V13L5 13L5 11L19 11Z" fill="white"/>
            </svg>
            <span className="dB ml5 c3E4044 f14 lh21">
              UBO/Shareholder
            </span>
          </Ripple>
        </div>
        <p className="mt25 mb20 f16 lh24">
          Please add all UBO’s (Ultimate Beneficial Owner), who holds a minimum of 20% of the company shares
        </p>
        {!loading && !!activeOwner && (
          <OwnerForm
            data={activeOwner}
            activeUserId={activeUserId}
            otherOwnersShares={otherOwnersShares}
            resetUserData={props.resetUserData}
            onNextStep={onNextStep}
            onSubmit={async (data) => {
              const {
                id,
                owner_document_identity,
                owner_document_address,
                identity_doc_data,
                address_doc_data,
                ...rest
              } = data;

              const isUpdate = !!activeOwner.full_name;

              const request = isUpdate
                ? requestUpdate
                : requestCreate;

              const params = {
                ...rest,
                identity_doc_id: (owner_document_identity || {}).id,
                address_doc_id: (owner_document_address || {}).id,
                account_id: activeUserId
              };

              if (isUpdate) {
                params['id'] = activeOwner.id;
              }

              return request(params).then((res) => {
                const id = res.id;
                const indexOfId = ownersListIDs.findIndex((key) => key === ownerId);

                const nextOwnersListIds = [...ownersListIDs];
                nextOwnersListIds[indexOfId] = id;

                setState({ownersListIDs: nextOwnersListIds});
                ownerId$.emit(id);
              })
            }}
          />
        )}
      </>
    )
  }
}, {
  ownerId: ownerId$
})
